/**
 * Service Worker Registration
 *
 * Registers the service worker, periodically checks for updates,
 * and automatically reloads the page when a new version is activated.
 */

const SW_UPDATE_CHECK_INTERVAL = 2 * 60 * 1000; // Check for SW updates every 2 minutes

let refreshing = false;

const handleWorkerStateChange = (newWorker: ServiceWorker) => {
  if (
    newWorker.state === "installed" &&
    navigator.serviceWorker.controller
  ) {
    console.log(
      "New service worker installed. Waiting for activation..."
    );
  }
};

const handleUpdateFound = (registration: ServiceWorkerRegistration) => {
  const newWorker = registration.installing;

  if (!newWorker) return;

  newWorker.addEventListener("statechange", () => {
    handleWorkerStateChange(newWorker);
  });
};

const registerSW = () => {
  navigator.serviceWorker
    .register("/sw.js", { scope: "/" })
    .then((registration) => {
      console.log("Service Worker registered successfully.");

      // Periodically check for service worker updates
      setInterval(() => {
        registration.update();
      }, SW_UPDATE_CHECK_INTERVAL);

      // When a new service worker is found installing
      registration.addEventListener("updatefound", () => {
        handleUpdateFound(registration);
      });
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
};

const handleControllerChange = () => {
  if (refreshing) return;

  refreshing = true;

  console.log("New service worker activated. Reloading page...");

  window.location.reload();
};

const handleSWMessage = (event: MessageEvent) => {
  if (event.data?.type === "SW_ACTIVATED") {
    console.log("Received SW_ACTIVATED message from service worker.");
  }
};

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) {
    console.warn("Service workers are not supported in this browser.");
    return;
  }

  window.addEventListener("load", () => {
    registerSW();

    // When a new service worker takes control, reload the page
    navigator.serviceWorker.addEventListener(
      "controllerchange",
      handleControllerChange
    );

    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener(
      "message",
      handleSWMessage
    );
  });
}